import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
export function useFocusGroupOptionController(props) {
  var groups = props.groups;
  var _React$useState = React.useState({
      group: -1,
      option: -1
    }),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    focusedIndex = _React$useState2[0],
    setFocusedIndex = _React$useState2[1];
  var moveFocus = React.useCallback(function (delta) {
    var group = groups[focusedIndex.group];
    if (!group) {
      return;
    }
    var groupsCount = groups.length;
    var optionsCount = group.options.length;
    var nextOptionIndex = focusedIndex.option + delta;
    var nextGroupIndex = focusedIndex.group + delta;
    if (nextOptionIndex < 0) {
      if (nextGroupIndex < 0) {
        return;
      }
      setFocusedIndex({
        group: nextGroupIndex,
        option: groups[nextGroupIndex].options.length - 1
      });
      return;
    }
    if (nextOptionIndex >= optionsCount) {
      if (nextGroupIndex >= groupsCount) {
        return;
      }
      setFocusedIndex({
        group: nextGroupIndex,
        option: 0
      });
      return;
    }
    setFocusedIndex({
      group: focusedIndex.group,
      option: nextOptionIndex
    });
  }, [groups, focusedIndex]);
  return {
    focusedIndex: focusedIndex,
    actions: {
      moveFocus: moveFocus,
      setFocusedIndex: setFocusedIndex
    }
  };
}